// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Observable } from 'rxjs';
// import { environment } from '../../environments/environment';

// export interface MakePremiumRequest {
//   phones: string[];
// }

// export interface MakePremiumResponse {
//   success: boolean;
//   message: string;
//   updatedCount: number;
// }

// @Injectable({
//   providedIn: 'root',
// })
// export class SupadminService {
//   private readonly baseUrl = environment.api_URL;

//   constructor(private http: HttpClient) {}

//   makePremiumUsers(phoneNumbers: string[]): Observable<MakePremiumResponse> {
//     const payload: MakePremiumRequest = { phones:phoneNumbers };
//     return this.http.post<MakePremiumResponse>(
//       `${this.baseUrl}/users/upgrade-premium`,
//       payload
//     );
//   }
// }


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// ─── Request ──────────────────────────────────────────────────────────────────
export interface MakePremiumRequest {
  phones: string[];
  durationMonths?: number;
  lastTransactionId?: string;
}

// ─── Response ─────────────────────────────────────────────────────────────────
export interface UpgradedUser {
  name: string;
  phone: string;
  membershipType: string;
  subscriptionStatus: string;
  subscriptionStartDate: string;
  subscriptionEndDate: string;
  lastTransactionId?: string;
}

export interface AlreadyPremiumUser {
  name: string;
  phone: string;
  existingSubscription: {
    membershipType: string;
    subscriptionStatus: string;
    subscriptionStartDate: string;
    subscriptionEndDate: string;
  };
}

export interface UpgradePremiumResponse {
  summary: {
    requested: number;
    upgraded: number;
    alreadyPremium: number;
    notFound: number;
  };
  upgraded: UpgradedUser[];
  alreadyPremium: AlreadyPremiumUser[];
  notFound: string[];
}

// ─── Service ──────────────────────────────────────────────────────────────────
@Injectable({ providedIn: 'root' })
export class SupadminService {
  private readonly baseUrl = environment.api_URL;

  constructor(private http: HttpClient) {}

  /**
   * POST /admin/users/make-premium
   * Grants premium access to one or more users by phone number.
   */
  makePremiumUsers(
    phones: string[],
    durationMonths?: number,
    lastTransactionId?: string,
  ): Observable<UpgradePremiumResponse> {
    const payload: MakePremiumRequest = {
      phones,
      ...(durationMonths ? { durationMonths } : {}),
      ...(lastTransactionId ? { lastTransactionId } : {}),
    };
    return this.http.post<UpgradePremiumResponse>(
      `${this.baseUrl}/users/upgrade-premium`,
      payload,
    );
  }
}


